import { useContext } from 'react';

import { DeleteLifeAreaContext } from './delete-life-area-context';

export const useOpenDeleteLifeAreaDialog = () => {
  const { onDeleteLifeArea } = useContext(DeleteLifeAreaContext);

  return onDeleteLifeArea;
};
